import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Transportista/addTransporte`, method: 'POST', body: values, token: token})
}